import * as React from 'react';
import { MessageBanner } from 'sos-common/js/components/MessageBanner/messageBanner';
import EventService from '../CalculationComponents/calculationComponents.eventservice';

export interface MessageBannerWrapperProps {
  showBannerOnRender: boolean;
}

export interface MessageBannerWrapperState {
  showBanner: boolean;
}

/**
 * The component subscribes to the EventService and renders the MessageBanner if SHOW_MESSAGEBAR event is fired
 * @param showBanner Defines if the banner will be rendered after component is mount
 */
export class MessageBannerWrapper extends React.Component<MessageBannerWrapperProps, MessageBannerWrapperState> {
  constructor(props: MessageBannerWrapperProps) {
    super(props);

    this.state = {
      showBanner: this.props.showBannerOnRender
    };
  }

  componentDidMount = () => {
      EventService.subscribe('SHOW_MESSAGEBAR', () => {
        this.setState({
            showBanner: true
        })
      });
  }

  onMessageClose = () => {
    this.setState({
      showBanner: false
    });
  };

  public render() {
    const { showBanner } = this.state;
    return <div>{showBanner && <MessageBanner onClose={this.onMessageClose} />}</div>;
  }
}
